<template>
  <div class="sms-test">
    <el-card class="sms-test-card">
      <div slot="header" class="sms-test-header">
        <span>短信验证码测试（无需登录）</span>
      </div>

      <el-form :model="form" label-width="90px">
        <el-form-item label="手机号">
          <el-input v-model="form.phone" maxlength="11" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="验证码">
          <div class="code-row">
            <el-input v-model="form.code" maxlength="4" placeholder="请输入短信验证码"></el-input>
            <el-button
              type="primary"
              :disabled="sending || countdown > 0"
              :loading="sending"
              @click="handleSend">
              {{ countdown > 0 ? `${countdown}s` : '发送验证码' }}
            </el-button>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="success" :loading="verifying" @click="handleVerify">校验验证码</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>

        <el-alert
          v-if="resultText"
          :title="resultText"
          :type="resultType"
          show-icon
          :closable="false"
          class="result-alert" />
      </el-form>

      <div class="tips">
        <div class="tips-title">提示</div>
        <div class="tips-item">发送接口：/api/user/sms/sendRegisterCode</div>
        <div class="tips-item">校验接口：/api/user/sms/verifyRegisterCode</div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { sendRegisterSmsCode, verifyRegisterSmsCode } from '@/api/user'

export default {
  name: 'SmsTest',
  data() {
    return {
      form: {
        phone: '',
        code: ''
      },
      sending: false,
      verifying: false,
      countdown: 0,
      timer: null,
      resultText: '',
      resultType: 'info'
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    validatePhone() {
      const phone = (this.form.phone || '').trim()
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(phone)) {
        this.$message.warning('请输入正确的手机号')
        return null
      }
      return phone
    },
    async handleSend() {
      const phone = this.validatePhone()
      if (!phone) return

      this.resultText = ''
      this.sending = true
      try {
        const res = await sendRegisterSmsCode(phone)
        if (res && res.code) {
          this.resultType = 'success'
          this.resultText = res.msg || '验证码已发送，请查收短信'
          this.startCountdown()
        } else {
          this.resultType = 'error'
          this.resultText = (res && res.msg) || '发送失败'
        }
      } catch (e) {
        this.resultType = 'error'
        this.resultText = '发送失败，请稍后重试'
      } finally {
        this.sending = false
      }
    },
    async handleVerify() {
      const phone = this.validatePhone()
      if (!phone) return

      const code = (this.form.code || '').trim()
      if (!code) {
        this.$message.warning('请输入验证码')
        return
      }

      this.resultText = ''
      this.verifying = true
      try {
        const res = await verifyRegisterSmsCode(phone, code)
        if (res && res.code) {
          this.resultType = 'success'
          this.resultText = res.msg || '验证码校验成功'
        } else {
          this.resultType = 'error'
          this.resultText = (res && res.msg) || '验证码校验失败'
        }
      } catch (e) {
        this.resultType = 'error'
        this.resultText = '验证码校验失败，请稍后重试'
      } finally {
        this.verifying = false
      }
    },
    handleReset() {
      this.form.phone = ''
      this.form.code = ''
      this.resultText = ''
      this.resultType = 'info'
      this.countdown = 0
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    startCountdown() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
          this.countdown = 0
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
.sms-test {
  padding: 20px;
}

.sms-test-card {
  max-width: 560px;
  margin: 0 auto;
}

.sms-test-header {
  font-weight: 600;
}

.code-row {
  display: flex;
  gap: 10px;
}

.result-alert {
  margin-top: 10px;
}

.tips {
  margin-top: 16px;
  color: #606266;
  font-size: 13px;
}

.tips-title {
  font-weight: 600;
  margin-bottom: 6px;
}

.tips-item {
  line-height: 1.7;
}
</style>
